import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstanceok5aued8gko9 as Companion_getInstance,
  get_debugMode2ku08uo1anfv as get_debugMode,
  report1vfr9zf0i9d9p as report,
} from '../debugger.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../views/ViewContextExtensions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../views/direct/ContainingView.commonHtml.mjs';
import {
  h22716j86ehrvde as h2,
  text1v7b2bj2gx49v as text,
  subtext2z3zzf0nosi4q as subtext,
} from '../views/direct/shortcuts.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { get_expanding10cuv3ua9vajx as get_expanding } from '../views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../views/direct/Button.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../models/Theme.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../views/l2/popoverHelpers.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sortWith4fnm6b3vw03s as sortWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ExceptionHandlers$Companion$root$o$handle$lambda() {
  return Unit_instance;
}
var ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass;
function ExceptionHandlers$Companion$root$o$handle$lambda$slambda() {
  if (ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass === VOID) {
    class $ {
      constructor($closer, $action, $view) {
        this.ncv_1 = $closer;
        this.ocv_1 = $action;
        this.pcv_1 = $view;
      }
      uao($completion) {
        this.ncv_1();
        this.ocv_1.zbe(this.pcv_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass = $;
  }
  return ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass;
}
function ExceptionHandlers$Companion$root$o$handle$lambda$slambda_0($closer, $action, $view) {
  var i = new (ExceptionHandlers$Companion$root$o$handle$lambda$slambda())($closer, $action, $view);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass_0;
function ExceptionHandlers$Companion$root$o$handle$lambda$slambda_1() {
  if (ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($closer) {
        this.qcv_1 = $closer;
      }
      uao($completion) {
        this.qcv_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass_0 = $;
  }
  return ExceptionHandlers$Companion$root$o$handle$lambda$slambdaClass_0;
}
function ExceptionHandlers$Companion$root$o$handle$lambda$slambda_2($closer) {
  var i = new (ExceptionHandlers$Companion$root$o$handle$lambda$slambda_1())($closer);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ExceptionHandlers$Companion$root$o$handle$lambda_0() {
  return Unit_instance;
}
var ExceptionHandlers$Companion$root$1Class;
function ExceptionHandlers$Companion$root$1() {
  if (ExceptionHandlers$Companion$root$1Class === VOID) {
    class $ {
      constructor() {
        this.rcv_1 = false;
      }
      g90() {
        return 0.0;
      }
      scv(view, working, exception) {
        if (this.rcv_1) {
          Companion_getInstance().icv(['Blocked ' + exception.toString() + '; already open']);
          return ExceptionHandlers$Companion$root$o$handle$lambda;
        }
        this.rcv_1 = true;
        closePopovers(view);
        var message = ensureNotNull(view.abb(exception));
        dialog(view, VOID, ($this$dialog, closer) => {
          onRemove($this$dialog, () => {
            this.rcv_1 = false;
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.gbb(p, view_0);
          view_0.zbm(true);
          h2(view_0, message.tcv_1);
          text(view_0, message.ucv_1);
          if (get_debugMode()) {
            subtext(view_0, stackTraceToString(exception));
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_0 = view_0.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view_0 : tmp0_elvis_lhs_0;
          view_0.gbb(p_0, view_1);
          view_1.zbm(false);
          var tmp = get_expanding(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Space())(view_1.pc());
          var tmp0_elvis_lhs_1 = view_1.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_1 : tmp0_elvis_lhs_1;
          view_1.gbb(p_1, view_2);
          view_1.hbb(p_1, view_2);
          view_1.lbb(tmp, view_2);
          var _iterator__ex2g4s = message.vcv_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var action = _iterator__ex2g4s.o1();
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (Button())(view_1.pc());
            var tmp0_elvis_lhs_2 = view_1.ebb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
            view_1.gbb(p_2, view_3);
            text(view_3, action.wcv());
            onClick(view_3, VOID, VOID, ExceptionHandlers$Companion$root$o$handle$lambda$slambda_0(closer, action, view));
            view_1.hbb(p_2, view_3);
          }
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp_0 = view_1.jbb(ButtonSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_4);
          text(view_4, 'OK');
          onClick(view_4, VOID, VOID, ExceptionHandlers$Companion$root$o$handle$lambda$slambda_2(closer));
          view_1.hbb(p_3, view_4);
          view_1.lbb(tmp_0, view_4);
          view_0.hbb(p_0, view_1);
          $this$dialog.hbb(p, view_0);
          return Unit_instance;
        });
        return ExceptionHandlers$Companion$root$o$handle$lambda_0;
      }
    }
    initMetadataForClass($);
    ExceptionHandlers$Companion$root$1Class = $;
  }
  return ExceptionHandlers$Companion$root$1Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.xcv_1 = true;
        var tmp = this;
        tmp.ycv_1 = new (ExceptionHandlers$Companion$root$1())();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.zcv_1 = function_0;
      }
      wi(a, b) {
        return this.zcv_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.zcv_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ExceptionHandlers$plusAssign$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.g90();
  var tmp$ret$1 = a.g90();
  return compareValues(tmp, tmp$ret$1);
}
var ExceptionHandlersClass;
function ExceptionHandlers() {
  if (ExceptionHandlersClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_0();
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.acw_1 = ArrayList().w();
      }
      scv(view, working, exception) {
        var tmp0 = this.acw_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var result = element.scv(view, working, exception);
            if (!(result == null)) {
              tmp$ret$1 = result;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        return tmp$ret$1;
      }
      vba(other) {
        this.acw_1.v(other);
        // Inline function 'kotlin.collections.sortByDescending' call
        var this_0 = this.acw_1;
        if (this_0.p1() > 1) {
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp = ExceptionHandlers$plusAssign$lambda;
          var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
          sortWith(this_0, tmp$ret$0);
        }
      }
    }
    initMetadataForClass($, 'ExceptionHandlers', ExceptionHandlers);
    ExceptionHandlersClass = $;
  }
  return ExceptionHandlersClass;
}
var ExceptionToMessages$Companion$root$1Class;
function ExceptionToMessages$Companion$root$1() {
  if (ExceptionToMessages$Companion$root$1Class === VOID) {
    class $ {
      g90() {
        return 0.0;
      }
      bcw(view, exception) {
        report(exception);
        return new (ExceptionMessage())('Error', 'An unknown error occurred.  If this issue persists, please contact the developers.');
      }
    }
    initMetadataForClass($);
    ExceptionToMessages$Companion$root$1Class = $;
  }
  return ExceptionToMessages$Companion$root$1Class;
}
var ExceptionToMessages$Companion$root$$inlined$apply$1Class;
function ExceptionToMessages$Companion$root$$inlined$apply$1() {
  if (ExceptionToMessages$Companion$root$$inlined$apply$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.ccw_1 = $priority;
      }
      g90() {
        return this.ccw_1;
      }
      bcw(view, exception) {
        if (!(exception instanceof PlainTextException()))
          return null;
        return new (ExceptionMessage())(exception.ecw_1, ensureNotNull(exception.message), exception.fcw_1);
      }
    }
    initMetadataForClass($);
    ExceptionToMessages$Companion$root$$inlined$apply$1Class = $;
  }
  return ExceptionToMessages$Companion$root$$inlined$apply$1Class;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (ExceptionToMessages())();
        this_0.icw(new (ExceptionToMessages$Companion$root$1())());
        // Inline function 'com.lightningkite.kiteui.exceptions.Companion.invoke' call
        var tmp$ret$0 = new (ExceptionToMessages$Companion$root$$inlined$apply$1())(1.0);
        this_0.icw(tmp$ret$0);
        tmp.jcw_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.kcw_1 = function_0;
      }
      wi(a, b) {
        return this.kcw_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.kcw_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function ExceptionToMessages$plusAssign$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.g90();
  var tmp$ret$1 = a.g90();
  return compareValues(tmp, tmp$ret$1);
}
var ExceptionToMessagesClass;
function ExceptionToMessages() {
  if (ExceptionToMessagesClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_1();
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.hcw_1 = ArrayList().w();
      }
      bcw(view, exception) {
        var tmp0 = this.hcw_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var result = element.bcw(view, exception);
            if (!(result == null)) {
              tmp$ret$1 = result;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        return tmp$ret$1;
      }
      icw(other) {
        this.hcw_1.v(other);
        // Inline function 'kotlin.collections.sortByDescending' call
        var this_0 = this.hcw_1;
        if (this_0.p1() > 1) {
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp = ExceptionToMessages$plusAssign$lambda;
          var tmp$ret$0 = new (sam$kotlin_Comparator$0_0())(tmp);
          sortWith(this_0, tmp$ret$0);
        }
      }
    }
    initMetadataForClass($, 'ExceptionToMessages', ExceptionToMessages);
    ExceptionToMessagesClass = $;
  }
  return ExceptionToMessagesClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var ExceptionMessageClass;
function ExceptionMessage() {
  if (ExceptionMessageClass === VOID) {
    class $ {
      constructor(title, body, actions) {
        var tmp;
        if (actions === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = actions;
        }
        actions = tmp;
        this.tcv_1 = title;
        this.ucv_1 = body;
        this.vcv_1 = actions;
      }
      toString() {
        return 'ExceptionMessage(title=' + this.tcv_1 + ', body=' + this.ucv_1 + ', actions=' + toString(this.vcv_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.tcv_1);
        result = imul(result, 31) + getStringHashCode(this.ucv_1) | 0;
        result = imul(result, 31) + hashCode(this.vcv_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExceptionMessage()))
          return false;
        if (!(this.tcv_1 === other.tcv_1))
          return false;
        if (!(this.ucv_1 === other.ucv_1))
          return false;
        if (!equals(this.vcv_1, other.vcv_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ExceptionMessage');
    ExceptionMessageClass = $;
  }
  return ExceptionMessageClass;
}
var PlainTextExceptionClass;
function PlainTextException() {
  if (PlainTextExceptionClass === VOID) {
    class $ extends Exception() {
      static lcw(message, title, actions) {
        title = title === VOID ? 'Error' : title;
        var tmp;
        if (actions === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = actions;
        }
        actions = tmp;
        var $this = this.ud(message);
        captureStack($this, $this.gcw_1);
        $this.ecw_1 = title;
        $this.fcw_1 = actions;
        return $this;
      }
    }
    initMetadataForClass($, 'PlainTextException');
    PlainTextExceptionClass = $;
  }
  return PlainTextExceptionClass;
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  ExceptionHandlers as ExceptionHandlers355q12ugblzqr,
  ExceptionMessage as ExceptionMessage21t2b5aa8xtox,
  PlainTextException as PlainTextException3c81a0qh9m2e2,
  Companion_getInstance_0 as Companion_getInstanceghpsqwa00d1o,
  Companion_instance_1 as Companion_instance2x38zxm4t0kdk,
  Companion_getInstance_1 as Companion_getInstance37g5wqg3e7ywq,
};
//endregion

//# sourceMappingURL=handling.mjs.map
